import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoadingSpinner from './LoadingSpinner';

// Step order for onboarding flow
const STEP_ORDER = ['welcome', 'billing', 'complete'];

const OnboardingRoute = ({ element, step }) => {
  const { user, status } = useSelector((state) => state.user);
  const location = useLocation();
  
  // Show loading while checking authentication
  if (status === "loading" || user === undefined) {
    return <LoadingSpinner message="Loading..." />;
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Special handling for completion step - always allow access to it
  if (step === 'complete') {
    return element;
  }

  // If no organization or onboarding is completed, redirect to main app
  // (but not for the completion step which we handled above)
  if (!user.organization || !user.organization.onboarding || user.organization.onboarding.isCompleted) {
    return <Navigate to="/rooms" replace />;
  }

  const onboarding = user.organization.onboarding;
  const currentStep = onboarding.currentStep || 'welcome';
  const completedSteps = onboarding.completedSteps || [];
  
  // If this is a specific onboarding step
  if (step) {
    const currentStepIndex = STEP_ORDER.indexOf(currentStep);
    const requestedStepIndex = STEP_ORDER.indexOf(step);
    
    // Allow access to:
    // 1. Current step
    // 2. Previously completed steps (for editing)
    // 3. Next step if current step is completed
    if (step === currentStep || 
        completedSteps.includes(step) || 
        (requestedStepIndex === currentStepIndex + 1 && completedSteps.includes(currentStep))) {
      return element;
    }
    
    // Otherwise redirect to current step
    return <Navigate to={`/onboarding/${currentStep}`} replace />;
  }

  // For any other route (non-onboarding), redirect to current onboarding step
  return <Navigate to={`/onboarding/${currentStep}`} replace />;
};

export default OnboardingRoute; 